export const handlePendingRequestActions = (state, action) => {
    if (state.status === "idle") {
        state.status = "loading";
        state.currentRequestId = action.meta.requestId;
    }
};

export const handleFulfilledRequestActions = (state, action) => {
    if (
        state.status === "loading" &&
        state.currentRequestId === action.meta.requestId
    ) {
        state.status = "idle";
        state.currentRequestId = undefined;
    }
};
